<template>
  <div class="box box_mm">
    <div class="box_main">
      <div class="search_box">
        <div class="search_item">
          <span style="width: 0.8rem">标题：</span>
          <el-input
            v-model="searchinput"
            placeholder="请输入"
            style="width: 2rem"
          ></el-input>
        </div>
        <div class="search_item">
          <span style="width: 0.8rem">分类：</span>
          <el-select
            v-model="searchfenlei"
            placeholder="请选择"
            filterable
            clearable
            style="width: 2.3rem"
            @change="search"
          >
            <el-option
              v-for="item in classifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="success" @click="usedcarexport">导出</el-button>
        </div>
      </div>
      <div class="box_cont">
        <div class="btn_list"></div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showbm="true"
            :czwidth="455"
            @getdata="gettable"
            @changswitch="changswitch"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button
                @click="showdetail2(scope.row)"
                type="primary"
                size="mini"
                >详情</el-button
              >
              <el-button @click="openEidt(scope.row)" type="warning" size="mini"
                >编辑</el-button
              >
              <el-button
                @click="showdetail(scope.row)"
                type="primary"
                size="mini"
                >查看文件</el-button
              >
              <el-button @click="bohui(scope.row)" type="warning" size="mini"
                >驳回</el-button
              >
              <el-button @click="pass(scope.row)" type="success" size="mini"
                >通过</el-button
              >
              <el-button
                @click="openEidtType(scope.row)"
                type="warning"
                size="mini"
                >修改分类</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <!--修改分类-->
    <el-dialog
      title="修改分类"
      :visible.sync="showEidtType"
      width="25%"
      :before-close="colseShowEidtType"
    >
      <div>
        <el-select
          v-model="sqmytype_name"
          placeholder="请选择"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in classifyData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colseShowEidtType">取 消</el-button>
        <el-button type="warning" @click="queren">确 定</el-button>
      </span>
    </el-dialog>

    <detail
      v-if="showtcdetail"
      :id="nowid"
      @closedetail="showtcdetail = false"
    ></detail>

    <detail_tcsj
      v-if="showtcsjdetail"
      :id="nowid"
      @closedetail="showtcsjdetail = false"
    ></detail_tcsj>
  </div>
</template>

<script>
import detail from "./detail_tc";
import detail_tcsj from "./detail_tcsj";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { Loading } from "element-ui";
export default {
  components: {
    detail,
    detail_tcsj,
  },
  data() {
    return {
      searchinput: "",
      searchfenlei: "",
      tableHeader: [
        {
          prop: "id",
          name: "序",
          width: "50",
        },
        {
          prop: "name",
          name: "标题",
          width: "",
        },
        {
          prop: "sqmytype_name",
          name: "所属类别",
          width: "150",
        },
        {
          prop: "sqmychannel_name",
          name: "来源渠道",
          width: "150",
        },
        {
          prop: "user_name",
          name: "发起人",
          width: "120",
        },
        {
          prop: "gbtype",
          name: "是否挂办",
          width: "120",
        },
        {
          prop: "state",
          name: "状态",
          width: "120",
          type: "sqmy_type",
        },
        {
          prop: "createtime",
          name: "创建时间",
          width: "150",
        },
      ],
      tableData: [],
      showtcdetail: false,
      showtcsjdetail: false,
      nowid: "",

      showEidtType: false,
      classifyData: [],
      sqmytype_name: "",
      loading: null,
    };
  },
  mounted() {
    this.$post({
      url: "/api/sqmytype/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.classifyData = res.list;
    });
    this.gettable();
  },
  methods: {
    usedcarexport() {
      this.loading = Loading.service({
        lock: true,
        text: "导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$post({
        url: "/api/sqmy/dcquan",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          state: 1,
        },
      })
        .then((res) => {
          res.list = res.list.map((item) => {
            item.state_name = this.stateFun(item.state);
            return item;
          });
          this.daochu(res.list);
        })
        .catch((err) => err);
    },
    stateFun(sta) {
      let tet = "";
      switch (sta) {
        case 1:
          tet = "待审核";
          break;
        case 2:
          tet = "待区政协审核";
          break;
        case 3:
          tet = "不予采纳";
          break;
        case 4:
          tet = "区政协采纳";
          break;
        case 5:
          tet = "区政协不予采纳";
          break;
        case 6:
          tet = "政府办采纳";
          break;
        case 7:
          tet = "政府办不予采纳";
          break;
        case 8:
          tet = "承办单位反馈";
          break;
        case 9:
          tet = "政府办反馈";
          break;
        case 10:
          tet = "已完结";
          break;
        case 11:
          tet = "采纳";
          break;

        default:
          break;
      }
      return tet;
    },
    daochu(arr) {
      // 数据数组
      let data = arr;

      // 表头名称映射
      const header = {
        name: "标题",
        sqmytype_name: "所属类别",
        sqmychannel_name: "来源渠道",
        user_name: "发起人",
        state_name: "状态",
        createtime: "创建时间",
      };

      // 创建工作簿对象
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet([Object.values(header)]);

      // 设置表头样式，可选
      const headerStyle = {
        font: { bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "00BFFF" } },
      };
      XLSX.utils.format_cell(worksheet["A1"], headerStyle);

      // 根据数据生成表格内容
      for (let i = 0; i < data.length; i++) {
        const row = [];
        for (const key in header) {
          if (header.hasOwnProperty(key)) {
            row.push(data[i][key]);
          }
        }
        XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: -1 });
      }

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 导出 Excel 文件
      XLSX.writeFile(workbook, "社情民意审核数据.xlsx");
      this.loading.close();
      this.$message.success("导出成功");
    },
    openEidt(row) {
      this.$router.push({
        path: "/system/people_opinions_list_add",
        query: { id: row.id },
      });
    },
    queren() {
      this.$post({
        url: "/api/sqmy/xgfl",
        params: {
          id: this.nowid,
          sqmytype_id: this.sqmytype_name,
        },
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.colseShowEidtType();
        this.gettable();
      });
    },
    openEidtType(row) {
      this.nowid = row.id;
      this.showEidtType = true;
    },
    colseShowEidtType() {
      this.nowid = "";
      this.showEidtType = false;
    },
    showdetail2(row) {
      this.nowid = row.id;
      this.showtcsjdetail = true;
    },
    showdetail(row) {
      this.nowid = row.id;
      this.showtcdetail = true;
    },
    bohui(row) {
      this.$prompt("请输入驳回理由", "提示", {
        confirmButtonText: "驳回",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入理由",
      })
        .then(({ value }) => {
          this.$post({
            url: "/api/sqmy/bohui",
            params: {
              id: row.id,
              sh_opinion: value,
            },
          }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.gettable();
          });
        })
        .catch(() => {});
    },
    pass(row) {
      this.$prompt("请输入批示内容", "提示", {
        confirmButtonText: "通过",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入",
      })
        .then(({ value }) => {
          this.$post({
            url: "/api/sqmy/tguo",
            params: {
              id: row.id,
              sh_opinion: value,
            },
          }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.gettable();
          });
        })
        .catch(() => {});
    },
    showeidt(row) {
      this.$router.push("/system/get_file/edit?id=" + row.id);
    },
    changswitch(row) {
      this.$post({
        url: "/api/room/edit",
        params: row,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.gettable();
      });
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/sqmy/quanindex",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          p: this.$refs.zjlist.inputpage,
          size: this.$refs.zjlist.pagesize,
          state: 1,
        },
      }).then((res) => {
        res.list.map((item) => {
          item.gbtype = item.gbtype == 2 ? "挂办" : "";
          return item;
        });
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;
      });
    },
    addnew() {
      this.$router.push("/system/get_file/add");
    },
    showdate(row) {
      this.$refs.myroomdate.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
